import apiService from '../apiService'
import { BASE_API, BASE_PORT_API } from '../../config/config'
import { getLocalStorage } from "../../helpers/functions/localStorage";
import { LOCAL_STORAGE } from "../../helpers/constants/localStorage";

export const authController = (configService = {}) => {
  const service = apiService(configService)
  return {
    loginByEmail: (params) => {
      return service.post(`/login`, params)
    },
    loginByPass: (params) => {
      return service.post(`/login/bypass`, params)
    },
    loginSearch: (params) => {
      return service.post(`/login/search`, params)
    },
    loginByCC: async () => {
      const me = await service.get(`${BASE_API}${BASE_PORT_API}/oauth/me`);
      if (!me) return false;
      // const currentEmail = getLocalStorage(LOCAL_STORAGE.CURRENT_EMAIL);
      // if (currentEmail && currentEmail.replace(/ /g, '').toLowerCase() !== me.user.email.replace(/ /g, '').toLowerCase()) {
      //   return {
      //     message: `This ${currentEmail} does not match the ${me.user.email} in the contact. Please contact BlueScope.`,
      //   };
      // }
      const params = {
        email: me.user.email,
        sfid: me.user.extension_rbpRollformerId
      }

      return service.post(`/login/search`, params)
    },
    logoutCC: async () => {
      // await service.get(`${BASE_API}${BASE_PORT_API}/oauth/sign-out-url-no-redirect`);
      window.location.href = `${BASE_API}${BASE_PORT_API}/oauth/sign-out-url`;
    }
  }
}
